module.exports = __webpack_public_path__ + "static/img/part1.9e839ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part1.svg
// module id = P41k
// module chunks = 0